import { LocalizedParagraph } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Icon, IconName, Stack } from '@optimus-web/core';
import { ListItemsIds } from '../../types';
import { MewsPaymentsInfo } from './MewsPaymentsInfo';
import { ListItemCardPaymentsLabel } from './ListItemCardPaymentsLabel';
import { ListItemEligibleCountriesLabel } from './ListItemEligibleCountriesLabel';

const listItems = [
    {
        id: ListItemsIds.BeInNetherlandsOrUK,
        label: <ListItemEligibleCountriesLabel />,
        icon: IconName.ActionLog,
    },
    {
        id: ListItemsIds.HaveMewsPayments,
        label: (
            <Stack vertical>
                <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalHaveMewsPayments} />
                <MewsPaymentsInfo />
            </Stack>
        ),
        icon: IconName.PaymentCard,
    },
    {
        id: ListItemsIds.HaveCardPayments,
        label: <ListItemCardPaymentsLabel />,
        icon: IconName.PaymentReport,
    },
];

export const NonEligibleRequirementsList = () => (
    <Stack vertical spacing="300">
        {listItems.map(({ label, id, icon }) => (
            <Stack key={id} spacing="200" itemAlignment="center">
                <Icon value={icon} />
                {label}
            </Stack>
        ))}
    </Stack>
);
